/**
 *
 */

import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import EmergencyPowerSettingsData from 'src/Elements/SystemSettings/EmergencyPower/EmergencyPowerSettingsData'
import { EmergencyPowerSettingsModel, SettingsFormModel } from 'src/Libs/emergency-power'
import SystemSettingsBlankView from 'src/Libs/system-settings/component/SystemSettingsBlankView'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  contentAccordion: {
    padding: theme.spacing(0),
  },
  headerContent: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(4),
    },
  },
}))

interface Props {
  model: EmergencyPowerSettingsModel | null
  onUpdate: (values: SettingsFormModel) => Promise<void>
  hasWritingRights?: boolean
}

/**
 * @constructor
 */
const EmergencyPowerSettings: React.FC<Props> = ({ model, onUpdate, hasWritingRights = true }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  const showWallboxSettings = model ? model.wallbox.maxBoundry >= model.wallbox.minEpPower : false

  return (
    <AccordionItem
      title={t('systemSettings.emergencyPower.settings.sectionTitle')}
      contentClassName={classes.contentAccordion}
      headerContentClassName={classes.headerContent}
    >
      {model ? (
        <EmergencyPowerSettingsData showWallboxSettings={showWallboxSettings} model={model} onUpdate={onUpdate} disabled={!hasWritingRights} />
      ) : (
        <SystemSettingsBlankView />
      )}
    </AccordionItem>
  )
}

export default EmergencyPowerSettings
